// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import {
    BillToCollectionModel,
    BillToModel,
    ShipToCollectionModel,
    ShipToModel,
} from "@insite/client-framework/Types/ApiModels";
import { OptionObject } from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";

interface CustomerData {
    model?: ShipToModel | BillToModel;
    totalPages: number;
    pagesFetched: number;
    options: OptionObject[];
}

export interface ChangeCustomerState {
    shipToId: string;
    billToId: string;
    shipTosLoading: Record<string, boolean>;
    billTosLoading: Record<string, boolean>;
    shipToDictionary: Record<string, CustomerData>;
    billToDictionary: Record<string, CustomerData>;
    billToSearchText: string;
    shipToSearchText: string;
}

const initialState: ChangeCustomerState = {
    shipToId: "",
    billToId: "",
    shipTosLoading: {},
    billTosLoading: {},
    shipToDictionary: {},
    billToDictionary: {},
    billToSearchText: "",
    shipToSearchText: "",
};

const reducer = {
    "Pages/ChangeCustomer/SetBillToSearchText": (draft: ChangeCustomerState, action: { searchText: string }) => {
        draft.billToSearchText = action.searchText;
    },
    "Pages/ChangeCustomer/SetShipToSearchText": (draft: ChangeCustomerState, action: { searchText: string }) => {
        draft.shipToSearchText = action.searchText;
    },
    "Pages/ChangeCustomer/SetShipToId": (draft: ChangeCustomerState, action: { id: string }) => {
        draft.shipToId = action.id;
    },
    "Pages/ChangeCustomer/SetBillToId": (draft: ChangeCustomerState, action: { id: string }) => {
        if (draft.billToId !== action.id) {
            draft.billToId = action.id;
            draft.shipToId = "";
            draft.shipToSearchText = "";
        }
    },

    "Pages/ChangeCustomer/BeginLoadNextShipToPage": (draft: ChangeCustomerState, action: { billToId: string }) => {
        const key = `${action.billToId}-${draft.shipToSearchText}`;
        draft.billTosLoading[key] = true;
    },
    "Pages/ChangeCustomer/CompleteLoadNextShipToPage": (
        draft: ChangeCustomerState,
        action: { model: ShipToCollectionModel; billToId: string },
    ) => {
        if (!action.model?.shipTos) {
            return draft;
        }
        const newOptions = action.model.shipTos.map(shipTo => ({
            optionValue: shipTo.id,
            optionText: shipTo.label,
        }));
        const key = `${action.billToId}-${draft.shipToSearchText}`;
        if (key in draft.shipToDictionary) {
            const currentCustomerData = draft.shipToDictionary[key];
            currentCustomerData.options = currentCustomerData.options.concat(newOptions);
            currentCustomerData.pagesFetched++;
        } else {
            draft.shipToDictionary[key] = {
                totalPages: action.model.pagination?.numberOfPages ?? 1,
                pagesFetched: 1,
                options: newOptions,
            };
        }
        draft.shipTosLoading[action.billToId] = false;
    },

    "Pages/ChangeCustomer/BeginLoadBillTo": (draft: ChangeCustomerState, action: { id: string }) => {
        draft.billToId = action.id;
        draft.billTosLoading[action.id] = true;
    },
    "Pages/ChangeCustomer/CompleteNextBillToPage": (
        draft: ChangeCustomerState,
        action: { model: BillToCollectionModel },
    ) => {
        if (!action.model?.billTos) {
            return draft;
        }
        const key = draft.billToSearchText;
        const newOptions = action.model.billTos.map(billTo => ({
            optionValue: billTo.id,
            optionText: billTo.label,
        }));
        if (key in draft.billToDictionary) {
            const currentCustomerData = draft.billToDictionary[draft.billToId];
            currentCustomerData.options = currentCustomerData.options.concat(newOptions);
            currentCustomerData.pagesFetched++;
        } else {
            draft.billToDictionary[key] = {
                totalPages: action.model.pagination?.numberOfPages ?? 1,
                pagesFetched: 1,
                options: newOptions,
            };
        }
        draft.billTosLoading[key] = false;
    },
    "Data/ChangeCustomer/Reset": () => {
        return initialState;
    },
};

const changeCustomerReducer = createTypedReducerWithImmer(initialState, reducer);
export type ChangeCustomerActions = Parameters<typeof changeCustomerReducer>[1];
export default changeCustomerReducer;
